import { render, staticRenderFns } from "./JSelectDepartTree.vue?vue&type=template&id=4a8c84a0&scoped=true&"
import script from "./JSelectDepartTree.vue?vue&type=script&lang=js&"
export * from "./JSelectDepartTree.vue?vue&type=script&lang=js&"
import style0 from "./JSelectDepartTree.vue?vue&type=style&index=0&id=4a8c84a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c84a0",
  null
  
)

export default component.exports